var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerStrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 698,
    height: 9,
    viewBox: "0 0 698 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02944 4.02944 0 9 0H689C693.971 0 698 4.02944 698 9H0Z",
    fill: "#D0004B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerStrip);
export default __webpack_public_path__ + "static/media/banner-strip.dcf25676ed006b5f4cb87ac01d3b3515.svg";
export { ForwardRef as ReactComponent };